import {createEntityAdapter} from '@reduxjs/toolkit';

export const canvasEngagementsAdapter = createEntityAdapter({
	selectId: (canvasEng) => canvasEng.id,
});
